import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useState, useEffect, useCallback } from 'react';
import { Carousel, CarouselVariant, Column, SliderNavColor, SliderNavVariant, } from '@as/cotopaxi';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_DESKTOP, MIN_SCREEN_WIDTH_DESKTOP_LARGE, } from '../../../constants/ScreenWidthConstants';
import { SLIDE_SPACING, SLIDES_AMOUNT_DESKTOP, SLIDES_AMOUNT_DESKTOP_LARGE } from '../../../constants/SliderConstants';
import { CompareProductsBarSlide } from './CompareProductsBarSlide';
export const CompareProductsBar = ({ comparisonProducts, addToBasket, getDeliveryPromise, deliveryPromiseExplanations, compareItemSelectSize, setSwiperInstance, }) => {
    const isMobile = useMediaQueryMatchesOnMobile();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const [compareProductsCarouselSwiper, setCompareProductsCarouselSwiper] = useState(null);
    const setSwiper = (swiper) => {
        setCompareProductsCarouselSwiper(swiper);
        setSwiperInstance(swiper);
    };
    useEffect(() => {
        if (compareProductsCarouselSwiper !== null) {
            compareProductsCarouselSwiper.update();
        }
    }, [comparisonProducts, compareProductsCarouselSwiper]);
    const compareProductsCarouselConfig = {
        variant: CarouselVariant.PRODUCT_TILE_NORMAL,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
        },
        showPagination: false,
        fullWidth: true,
        withDivider: isMobile,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            navigation: {
                prevEl: undefined,
                nextEl: undefined,
            },
            renderPrevButton: undefined,
            renderNextButton: undefined,
            getSwiper: setSwiper,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView: 'auto',
                    spaceBetween: SLIDE_SPACING.TABLET,
                },
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
                [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP_LARGE,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const compareSlide = useCallback((product) => (_jsx(Column, { gutter: false, grid: 4, desktop: 3, tablet: 4, tabletSmall: 4, children: _jsx(CompareProductsBarSlide, { product: product, addToBasket: addToBasket, getDeliveryPromise: getDeliveryPromise, deliveryPromiseExplanations: deliveryPromiseExplanations, compareItemSelectSize: compareItemSelectSize }) }, `${product.productCode}${product.colourId}`)), [comparisonProducts, isMobile, isDesktop]);
    return _jsx(Carousel, Object.assign({}, compareProductsCarouselConfig, { children: comparisonProducts.map(compareSlide) }));
};
